import { createAppSlice } from "./createAppSlice";

const initialState = {
    modalId: null,
    link: "",
    download: false,
    source: "",
};

export const businessModalSlice = createAppSlice({
    name: "businessModal",
    initialState,
    reducers: {
        closeModal: state => {
            state = initialState;
            return state;
        },
        openModal: (state, action) => {
            state = action.payload;
            return state;
        },
    },
    selectors: {
        selectModalData: state => state,
        selectModalId: state => state.modalId,
    },
});

export const { closeModal, openModal } = businessModalSlice.actions;

export const { selectModalData, selectModalId } = businessModalSlice.selectors;
